import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as echarts from 'echarts';
//引入路由
import router from './router'
import axios from 'axios'
//引入全局样式
import './style/app.css'
import 'inter-ui/inter.css'
import '@fontsource/noto-sans-tc'
// 引入全局语言管理 - 修复导入
import { initGlobalLanguage, initLanguageWatcher } from '@/components/utils/language'  // 添加这行

//使用路由
const app = createApp(App)

// 初始化语言 - 现在可以正常调用
initGlobalLanguage();
// 初始化语言监听器
initLanguageWatcher();

//挂载到全局属性中 方便调用
app.config.globalProperties.$http = axios
app.config.globalProperties.$echarts = echarts
//挂载路由
app.use(router)
//挂载ElementPlus
app.use(ElementPlus)
app.mount('#app')